<template>
  <div class="yo-ans-content-switch">
    <div class="yo-content-block" v-if="question.ansType === 'many-ans-mc'">
      <h2 style="display: inline-block;">
        Multiple Answer MC
      </h2>
      <el-button type="danger" @click="resetAnsType">X</el-button>
      <RespMaMC @saveTo="saveTo" :question="question" @view="(v) => { $emit('view', v) }" mode="edit"></RespMaMC>
    </div>
    <div class="yo-content-block" v-if="question.ansType === 'one-ans-mc'">
      <h2 style="display: inline-block;">
        Single Answer MC
      </h2>
      <el-button type="danger" @click="resetAnsType">X</el-button>
      <RespSaMC @saveTo="saveTo" :question="question" @view="(v) => { $emit('view', v) }" mode="edit"></RespSaMC>
    </div>
    <div class="yo-content-block" v-if="question.ansType === 'text-ans'">
      <h2 style="display: inline-block;">
        Text Answer
      </h2>
      <el-button type="danger" @click="resetAnsType">X</el-button>
      <RespText @saveTo="saveTo" :question="question" @view="(v) => { $emit('view', v) }" mode="edit"></RespText>
    </div>
    <div class="yo-content-block" v-if="question.ansType === 'math-eq-ans'">
      <h2 style="display: inline-block;">
        Math Equation Doodle
      </h2>
      <el-button type="danger" @click="resetAnsType">X</el-button>
      <RespMathDoodle @saveTo="saveTo" :question="question" @view="(v) => { $emit('view', v) }" mode="edit"></RespMathDoodle>
    </div>
    <div class="yo-content-block" v-if="question.ansType === 'range-val-ans'">
      <h2 style="display: inline-block;">
        Ranged Value Answer
      </h2>
      <el-button type="danger" @click="resetAnsType">X</el-button>
      <RespRangedValue @saveTo="saveTo" :question="question" @view="(v) => { $emit('view', v) }" mode="edit"></RespRangedValue>
    </div>
    <div class="yo-content-block" v-if="question.ansType === 'open-end-ans'">
      <h2 style="display: inline-block;">
        Open Ended Question / Survey
      </h2>
      <el-button type="danger" @click="resetAnsType">X</el-button>
      <RespOpenEnd @saveTo="saveTo" :question="question" @view="(v) => { $emit('view', v) }" mode="edit"></RespOpenEnd>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    RespMathDoodle: require('../yoqb-compos/RespMathDoodle.vue').default,
    RespOpenEnd: require('../yoqb-compos/RespOpenEnd.vue').default,
    RespRangedValue: require('../yoqb-compos/RespRangedValue.vue').default,
    RespText: require('../yoqb-compos/RespText.vue').default,
    RespMaMC: require('../yoqb-compos/RespMaMC.vue').default,
    RespSaMC: require('../yoqb-compos/RespSaMC.vue').default
  },
  props: {
    question: {}
  },
  methods: {
    saveTo (v) {
      this.$emit('saveTo', v)
    },
    resetAnsType() {
      this.question.ansType = 'unknown'
      // if (window.confirm(`Reset Answer Type? \nAre you sure?`)) {
      //   this.question.ansType = 'unknown'
      // }
    }
  }
}
</script>

<style>

</style>
